import { render, staticRenderFns } from "./catequest_base_detail.vue?vue&type=template&id=752c40e5"
import script from "./catequest_base_detail.vue?vue&type=script&lang=js"
export * from "./catequest_base_detail.vue?vue&type=script&lang=js"
import style0 from "./catequest_base_detail.vue?vue&type=style&index=0&id=752c40e5&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('752c40e5')) {
      api.createRecord('752c40e5', component.options)
    } else {
      api.reload('752c40e5', component.options)
    }
    module.hot.accept("./catequest_base_detail.vue?vue&type=template&id=752c40e5", function () {
      api.rerender('752c40e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/catequest/catequest_base_detail.vue"
export default component.exports